import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

const defaultProps = {
  items: 8,
  top: 55,
  height: 39,
};

const propTypes = {
  items: PropTypes.number,
  top: PropTypes.number,
  height: PropTypes.number,
};

export class FormLoader extends React.Component {

  shouldComponentUpdate() {
    return false;
  }

  render() {
    let rows = [];
    const styles = {};
    if(this.props.height) styles.height = this.props.height;
    
    for(let i = 0; i < this.props.items; i += 1) {
      rows.push(<div key={i} className={inputMock} style={styles} />)
    }

    return (
      <div className={wrapper} style={{marginTop: this.props.top}}>
        {rows}
      </div>
    );
  }
}

FormLoader.defaultProps = defaultProps;
FormLoader.propTypes = propTypes;
export default FormLoader;

const wrapper = css`
  overflow: hidden;
  max-height: 100vh;
`;

const inputMock = css`
  background: rgba(206, 206, 206, 0.19);
  border-radius: 4px;
  width: 100%;
  margin-bottom: 34px;
`;


// WEBPACK FOOTER //
// ./src/components/loaders/FormLoader.jsx